/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/react-in-jsx-scope */
import React, { useEffect } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import Logo from "../../../assets/images/black_logo.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Paragraph from "../../../components/core/typography/Paragraph";
import Button from "../../../components/core/form-components/Button";
import { pathRoute } from "../../../routes/PathRoute";
import { hideLoader, showLoader } from "../../../redux/slices/siteLoaderSlice";
import { useDispatch, useSelector } from "react-redux";
import { setToken, setUser } from "../../../redux/slices/userSlice";
import { LanguageTranslation } from "../../../components/language-translation/LanguageTranslation";
import { languageIdSelector } from "../../../redux/slices/website/languageSlice";
import { ToastShow } from "../../../redux/slices/toastSlice";
import { resetPasswordValidationSchemaThoughEmail } from "../../../validations/website/resetPasswordValidationSchema";
import InputType from "../../../components/core/form-components/InputType";
import { SetNewPassword } from "../../../services/website/authService";

function SetPassword(): JSX.Element {
  const language = useSelector(languageIdSelector);
  const langId = language?.languageId ?? "fr";
  const dispatch = useDispatch();
  const { state } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!state?.userId) {
      navigate(pathRoute?.auth?.login);
    }
  }, [state?.userId, navigate]);
  const handleSubmit = async (values: {
    new_password: string;
    confirm_password: string;
  }) => {
    dispatch(showLoader());
    const userId = state?.userId;
    try {
      const params = {
        newPassword: values.new_password,
        confirmPassword: values.confirm_password, // ✅ Added confirmPassword
      };
      const response = await SetNewPassword(userId, params);
      if (response?.data?.code === 200) {
        navigate(pathRoute?.auth?.profileSetup, {
          state: { userId: response?.data?.userId },
        });
      }
    } catch (error: any) {
      console.error("Password reset error:", error);
      const messageKey =
        error?.response?.data?.message_key ||
        error?.data?.message_key ||
        error?.message_key;

      const translatedMessage = LanguageTranslation({
        labelName: messageKey || "",
        languageCode: langId || "fr",
      });

      dispatch(
        ToastShow({
          message:
            translatedMessage ||
            error?.data?.message ||
            "Password reset failed",
          type: "error",
        })
      );
    } finally {
      dispatch(hideLoader());
    }
  };

  return (
    <div className="xl:px-[105px] lg:px-[60px] md:px-10 px-3 xxl:pt-15 lg:py-10 py-[30px]">
      <div className="text-center xl:mb-[60px] lg:mb-[40px] mb-[30px]">
        <img
          src="/black_logo.svg"
          alt="logo"
          title="ArtGapi"
          width={180}
          height={74}
          className="text-center inline-block"
        />
      </div>
      <Paragraph text24 className="mb-[12px] !font-semibold">
        {LanguageTranslation({
          labelName: "web_what_is_your_password",
          languageCode: langId,
        }) || "What's your password?"}
      </Paragraph>

      <Formik
        initialValues={{ new_password: "", confirm_password: "" }}
        validationSchema={resetPasswordValidationSchemaThoughEmail(langId)}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, errors, touched }) => (
          <Form>
            <div className="grid grid-cols-12">
              <div className="col-span-12 mb-4">
                <InputType
                  type="password"
                  name="new_password"
                  placeholder={
                    LanguageTranslation({
                      labelName: "web_new_password",
                      languageCode: langId,
                    }) || "New Password"
                  }
                  className="w-full"
                  error={touched.new_password && errors.new_password}
                />
              </div>
              <div className="col-span-12 mb-4">
                <InputType
                  type="password"
                  name="confirm_password"
                  placeholder={
                    LanguageTranslation({
                      labelName: "web_confirm_password",
                      languageCode: langId,
                    }) || "Confirm Password"
                  }
                  className="w-full"
                  error={touched.confirm_password && errors.confirm_password}
                     onPaste={(e: any) => {
                    e.preventDefault(); // block paste
                  }}
                />
              </div>
              <div className="col-span-12 mb-4">
                <Button
                  primary
                  className="w-full"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {LanguageTranslation({
                    labelName: "web_next",
                    languageCode: langId,
                  }) || "Next"}
                </Button>
              </div>
        
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default SetPassword;
